import { render, staticRenderFns } from "./Choices.vue?vue&type=template&id=495cfd9c&scoped=true&lang=pug"
import script from "./Choices.vue?vue&type=script&lang=js"
export * from "./Choices.vue?vue&type=script&lang=js"
import style0 from "./Choices.vue?vue&type=style&index=0&id=495cfd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495cfd9c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
